var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarHelp24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toolbar-help 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toolbar-help"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0752 18.0752 23 12 23C5.92486 23 1 18.0752 1 12C1 5.92486 5.92486 1 12 1C18.0752 1 23 5.92486 23 12ZM12 7.875C11.4928 7.875 11.048 8.14893 10.8081 8.5635C10.4279 9.22084 9.58675 9.44546 8.92942 9.06521C8.27209 8.68496 8.04747 7.84383 8.42771 7.1865C9.13887 5.95712 10.4715 5.125 12 5.125C14.2782 5.125 16.125 6.97183 16.125 9.25C16.125 11.0461 14.9771 12.5741 13.375 13.1403V13.375C13.375 14.1344 12.7594 14.75 12 14.75C11.2406 14.75 10.625 14.1344 10.625 13.375V12C10.625 11.2406 11.2406 10.625 12 10.625C12.7594 10.625 13.375 10.0094 13.375 9.25C13.375 8.49062 12.7594 7.875 12 7.875ZM12 18.875C12.7594 18.875 13.375 18.2594 13.375 17.5C13.375 16.7406 12.7594 16.125 12 16.125C11.2406 16.125 10.625 16.7406 10.625 17.5C10.625 18.2594 11.2406 18.875 12 18.875Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarHelp24);
export default __webpack_public_path__ + "static/media/toolbar-help-24.ee45c549b5f8d6ed4aaedfa4ce38cb1a.svg";
export { ForwardRef as ReactComponent };